export default "__VITE_ASSET__D$1Wcr0L__"